export default __webpack_public_path__ + "static/media/3_123compare.me.99264cb6.svg";